.aq{flex-shrink:0;}